import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  ArrowUpRight, 
  Building2,
  Home,
  TrendingUp,
  FileText,
  Search,
  Scale,
  HandshakeIcon,
  MapPin,
  Euro,
  ClipboardCheck,
  Users,
  Shield,
  Star,
  Quote,
  Calendar,
  ChevronRight,
  Send,
  Phone,
  Mail
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RealEstatePage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    tipoRichiesta: '',
    tipoImmobile: '',
    zona: '',
    budget: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.nome,
          email: formData.email,
          phone: formData.telefono,
          subject: `Richiesta Immobiliare: ${formData.tipoRichiesta}`,
          message: `
Tipo Richiesta: ${formData.tipoRichiesta}
Tipo Immobile: ${formData.tipoImmobile}
Zona di Interesse: ${formData.zona}
Budget: ${formData.budget}

Messaggio:
${formData.messaggio}
          `.trim()
        })
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefono: '',
          tipoRichiesta: '',
          tipoImmobile: '',
          zona: '',
          budget: '',
          messaggio: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
    
    setIsSubmitting(false);
    setTimeout(() => setSubmitStatus(null), 5000);
  };

  const fadeUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  const services = [
    {
      id: 'valutazione',
      icon: <Euro className="w-8 h-8" />,
      title: 'Valutazione Immobiliare',
      description: 'Analisi accurate del valore di mercato per immobili residenziali e commerciali, basate su dati concreti e conoscenza del territorio.',
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGludGVyaW9yJTIwcmVhbCUyMGVzdGF0ZXxlbnwwfHx8fDE3ODc2NjA2NzB8MA&ixlib=rb-4.1.0&q=85',
      features: [
        {
          icon: <Search className="w-5 h-5" />,
          title: 'Analisi di Mercato',
          description: 'Studio approfondito del mercato locale per determinare il giusto prezzo.'
        },
        {
          icon: <FileText className="w-5 h-5" />,
          title: 'Perizie Immobiliari',
          description: 'Valutazioni tecniche dettagliate per banche e procedure legali.'
        },
        {
          icon: <TrendingUp className="w-5 h-5" />,
          title: 'Previsioni di Mercato',
          description: 'Analisi delle tendenze per investimenti strategici.'
        },
        {
          icon: <ClipboardCheck className="w-5 h-5" />,
          title: 'Due Diligence',
          description: 'Verifica completa della documentazione e stato giuridico.'
        }
      ]
    },
    {
      id: 'compravendita',
      icon: <HandshakeIcon className="w-8 h-8" />,
      title: 'Assistenza Compravendita',
      description: 'Supporto completo in ogni fase della trattativa, dalla ricerca dell\'immobile ideale fino al rogito notarile.',
      image: 'https://images.unsplash.com/photo-1673403731036-30ef7a4995f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxpdGFsaWFuJTIwdmlsbGElMjBtZWRpdGVycmFuZWFuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NzY2MDY3MHww&ixlib=rb-4.1.0&q=85',
      features: [
        {
          icon: <Search className="w-5 h-5" />,
          title: 'Ricerca Immobili',
          description: 'Selezione accurata che corrisponde alle tue esigenze.'
        },
        {
          icon: <Scale className="w-5 h-5" />,
          title: 'Negoziazione',
          description: 'Rappresentanza professionale per le migliori condizioni.'
        },
        {
          icon: <FileText className="w-5 h-5" />,
          title: 'Gestione Contrattuale',
          description: 'Preparazione e revisione di tutti i documenti.'
        },
        {
          icon: <Shield className="w-5 h-5" />,
          title: 'Tutela Legale',
          description: 'Protezione dei tuoi interessi in ogni fase.'
        }
      ]
    },
    {
      id: 'investimenti',
      icon: <Building2 className="w-8 h-8" />,
      title: 'Consulenza Investimenti',
      description: 'Strategie di investimento immobiliare per massimizzare il rendimento del tuo capitale nel lungo termine.',
      image: 'https://images.unsplash.com/photo-1638885930125-85350348d266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGludGVyaW9yJTIwcmVhbCUyMGVzdGF0ZXxlbnwwfHx8fDE3ODc2NjA2NzB8MA&ixlib=rb-4.1.0&q=85',
      features: [
        {
          icon: <TrendingUp className="w-5 h-5" />,
          title: 'Analisi ROI',
          description: 'Calcolo dettagliato del ritorno sull\'investimento.'
        },
        {
          icon: <MapPin className="w-5 h-5" />,
          title: 'Scouting Opportunità',
          description: 'Zone ad alto potenziale di rivalutazione.'
        },
        {
          icon: <Users className="w-5 h-5" />,
          title: 'Gestione Locazioni',
          description: 'Consulenza per affitti a lungo termine o turistici.'
        },
        {
          icon: <Building2 className="w-5 h-5" />,
          title: 'Portfolio Immobiliare',
          description: 'Strategia di diversificazione del patrimonio.'
        }
      ]
    },
    {
      id: 'ristrutturazioni',
      icon: <Home className="w-8 h-8" />,
      title: 'Consulenza Ristrutturazioni',
      description: 'Supporto nella pianificazione di interventi di ristrutturazione per valorizzare il tuo immobile.',
      image: 'https://images.pexels.com/photos/28460175/pexels-photo-28460175.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      features: [
        {
          icon: <ClipboardCheck className="w-5 h-5" />,
          title: 'Analisi Costi-Benefici',
          description: 'Valutazione degli interventi più efficaci.'
        },
        {
          icon: <FileText className="w-5 h-5" />,
          title: 'Bonus e Incentivi',
          description: 'Consulenza su detrazioni fiscali e agevolazioni.'
        },
        {
          icon: <Users className="w-5 h-5" />,
          title: 'Network Professionisti',
          description: 'Accesso a architetti e imprese di fiducia.'
        },
        {
          icon: <Shield className="w-5 h-5" />,
          title: 'Project Management',
          description: 'Coordinamento lavori per rispettare tempi e budget.'
        }
      ]
    }
  ];

  const testimonials = [
    {
      name: 'Marco Bianchi',
      role: 'Imprenditore',
      location: 'Milano',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
      text: 'Grazie alla consulenza di Carone Consulting ho venduto il mio appartamento al miglior prezzo di mercato in tempi record. Professionalità e competenza straordinarie.',
      rating: 5
    },
    {
      name: 'Giulia Rossi',
      role: 'Architetto',
      location: 'Roma',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face',
      text: 'Ho trovato la casa dei miei sogni grazie al loro servizio di ricerca personalizzata. Ogni dettaglio è stato curato con attenzione e dedizione.',
      rating: 5
    },
    {
      name: 'Roberto Verdi',
      role: 'Investitore',
      location: 'Napoli',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
      text: 'La consulenza sugli investimenti immobiliari mi ha permesso di costruire un portfolio redditizio. Analisi di mercato impeccabili e consigli sempre azzeccati.',
      rating: 5
    }
  ];

  const blogPosts = [
    {
      title: 'Come Valutare un Immobile nel 2024',
      excerpt: 'Guida completa ai fattori che influenzano il valore di un immobile nel mercato attuale.',
      category: 'Valutazione',
      date: '15 Dic 2024',
      image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=250&fit=crop'
    },
    {
      title: '5 Errori da Evitare nell\'Acquisto Casa',
      excerpt: 'I principali errori che commettono gli acquirenti e come evitarli per un investimento sicuro.',
      category: 'Compravendita',
      date: '10 Dic 2024',
      image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=400&h=250&fit=crop'
    },
    {
      title: 'Bonus Casa 2025: Tutte le Novità',
      excerpt: 'Le nuove detrazioni fiscali per ristrutturazioni e efficientamento energetico.',
      category: 'Ristrutturazioni',
      date: '5 Dic 2024',
      image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=400&h=250&fit=crop'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F4F5F7]" data-testid="real-estate-page">
      {/* Hero Section with Image */}
      <section className="pt-24 pb-20 relative overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1674758979141-4e3521ba7321?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwdmlsbGElMjBtZWRpdGVycmFuZWFuJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NzY2MDY3MHww&ixlib=rb-4.1.0&q=85"
            alt="Villa italiana"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1A1D24]/90 via-[#1A1D24]/70 to-[#1A1D24]/40" />
        </div>
        
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 pt-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="max-w-2xl"
          >
            <span className="text-[#2DD4BF] text-sm font-semibold tracking-wider uppercase mb-4 block">
              Consulenza Immobiliare
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
              Il Tuo Partner di Fiducia nel Settore Immobiliare
            </h1>
            <p className="text-lg text-white/80 leading-relaxed mb-8">
              Esperienza, competenza e dedizione al servizio dei tuoi progetti immobiliari. 
              Ti accompagniamo in ogni fase, dalla valutazione all'acquisto, dalla vendita all'investimento.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#form-immobiliare"
                data-testid="real-estate-hero-cta"
                className="inline-flex items-center gap-2 bg-[#2DD4BF] text-white px-8 py-4 font-semibold rounded-sm hover:bg-[#14B8A6] transition-all hover:scale-105 shadow-lg"
              >
                Richiedi una Consulenza Gratuita
                <ArrowUpRight size={20} />
              </a>
              <a
                href="tel:+393331234567"
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-8 py-4 font-semibold rounded-sm hover:bg-white/20 transition-all"
              >
                <Phone size={20} />
                Chiamaci Ora
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-white border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { value: '500+', label: 'Immobili Gestiti' },
              { value: '15+', label: 'Anni di Esperienza' },
              { value: '98%', label: 'Clienti Soddisfatti' },
              { value: '€50M+', label: 'Volume Transazioni' }
            ].map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-center"
              >
                <div className="text-3xl md:text-4xl font-bold text-[#2DD4BF] mb-1">{stat.value}</div>
                <div className="text-sm text-[#6B7280]">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-[#F4F5F7]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeUp} className="text-center mb-12">
            <span className="text-[#2DD4BF] text-sm font-semibold tracking-wider uppercase mb-4 block">
              Perché Noi
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1A1D24] tracking-tight">
              Perché Scegliere la Nostra Consulenza Immobiliare
            </h2>
          </motion.div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { 
                icon: <Shield className="w-6 h-6" />,
                title: 'Trasparenza Totale', 
                description: 'Ogni passaggio viene condiviso con te. Nessuna sorpresa, solo decisioni informate.' 
              },
              { 
                icon: <Users className="w-6 h-6" />,
                title: 'Approccio Personalizzato', 
                description: 'Ogni cliente è unico. Costruiamo strategie su misura per le tue esigenze.' 
              },
              { 
                icon: <TrendingUp className="w-6 h-6" />,
                title: 'Esperienza Comprovata', 
                description: 'Anni di esperienza nel mercato immobiliare locale e nazionale.' 
              }
            ].map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white p-8 rounded-lg shadow-sm border border-[#E5E7EB] hover:shadow-lg transition-all"
              >
                <div className="w-14 h-14 rounded-full bg-[#2DD4BF]/10 flex items-center justify-center text-[#2DD4BF] mb-4">
                  {item.icon}
                </div>
                <h3 className="text-lg font-semibold text-[#1A1D24] mb-2">{item.title}</h3>
                <p className="text-[#6B7280] text-sm leading-relaxed">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Services List with Images */}
      {services.map((service, serviceIndex) => (
        <section
          key={service.id}
          id={service.id}
          className={`py-24 md:py-32 ${serviceIndex % 2 === 0 ? 'bg-white' : 'bg-[#F4F5F7]'}`}
        >
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className={`grid lg:grid-cols-2 gap-12 items-center ${serviceIndex % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
              {/* Image */}
              <motion.div
                initial={{ opacity: 0, x: serviceIndex % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className={`${serviceIndex % 2 === 1 ? 'lg:order-2' : ''}`}
              >
                <div className="relative rounded-lg overflow-hidden shadow-2xl">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-[300px] md:h-[400px] object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A1D24]/50 to-transparent" />
                  <div className="absolute bottom-6 left-6">
                    <div className="w-14 h-14 rounded-lg bg-[#2DD4BF] flex items-center justify-center text-white">
                      {service.icon}
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Content */}
              <motion.div {...fadeUp} className={`${serviceIndex % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1A1D24] tracking-tight mb-4">
                  {service.title}
                </h2>
                <p className="text-[#4B5563] text-lg leading-relaxed mb-8">
                  {service.description}
                </p>

                <div className="grid sm:grid-cols-2 gap-4">
                  {service.features.map((feature, featureIndex) => (
                    <motion.div
                      key={feature.title}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: featureIndex * 0.1 }}
                      data-testid={`real-estate-feature-${service.id}-${featureIndex}`}
                      className="flex items-start gap-3 p-4 bg-[#F9FAFB] rounded-lg border border-[#E5E7EB]"
                    >
                      <div className="w-8 h-8 rounded-lg bg-[#2DD4BF]/10 flex items-center justify-center text-[#2DD4BF] flex-shrink-0">
                        {feature.icon}
                      </div>
                      <div>
                        <h4 className="font-semibold text-[#1A1D24] text-sm mb-1">{feature.title}</h4>
                        <p className="text-[#6B7280] text-xs leading-relaxed">{feature.description}</p>
                      </div>
                    </motion.div>
                  ))}
                </div>

                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className="mt-8"
                >
                  <a
                    href="#form-immobiliare"
                    data-testid={`real-estate-cta-${service.id}`}
                    className="inline-flex items-center gap-2 text-[#2DD4BF] font-medium hover:gap-3 transition-all"
                  >
                    Richiedi informazioni su {service.title}
                    <ArrowUpRight size={18} />
                  </a>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
      ))}

      {/* Testimonials Section */}
      <section className="py-24 bg-[#1A1D24]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeUp} className="text-center mb-16">
            <span className="text-[#2DD4BF] text-sm font-semibold tracking-wider uppercase mb-4 block">
              Testimonianze
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
              Cosa Dicono i Nostri Clienti
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`testimonial-${index}`}
                className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-lg relative"
              >
                <Quote className="absolute top-6 right-6 w-8 h-8 text-[#2DD4BF]/30" />
                
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#2DD4BF] text-[#2DD4BF]" />
                  ))}
                </div>
                
                <p className="text-white/80 leading-relaxed mb-6 text-sm">
                  "{testimonial.text}"
                </p>
                
                <div className="flex items-center gap-4">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                  <div>
                    <div className="font-semibold text-white">{testimonial.name}</div>
                    <div className="text-white/50 text-sm">{testimonial.role} • {testimonial.location}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Real Estate Form Section */}
      <section id="form-immobiliare" className="py-24 bg-[#F4F5F7]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Form Info */}
            <motion.div {...fadeUp}>
              <span className="text-[#2DD4BF] text-sm font-semibold tracking-wider uppercase mb-4 block">
                Contattaci
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1A1D24] tracking-tight mb-6">
                Richiedi una Consulenza Personalizzata
              </h2>
              <p className="text-[#4B5563] text-lg leading-relaxed mb-8">
                Compila il form con i tuoi dati e le tue esigenze. Ti ricontatteremo entro 24 ore 
                per fissare un appuntamento gratuito e senza impegno.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-[#E5E7EB]">
                  <div className="w-12 h-12 rounded-full bg-[#2DD4BF]/10 flex items-center justify-center text-[#2DD4BF]">
                    <Phone size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-[#6B7280]">Telefono</div>
                    <div className="font-semibold text-[#1A1D24]">+39 333 123 4567</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-[#E5E7EB]">
                  <div className="w-12 h-12 rounded-full bg-[#2DD4BF]/10 flex items-center justify-center text-[#2DD4BF]">
                    <Mail size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-[#6B7280]">Email</div>
                    <div className="font-semibold text-[#1A1D24]">info@caroneconsulting.it</div>
                  </div>
                </div>
                <div className="flex items-center gap-4 p-4 bg-white rounded-lg border border-[#E5E7EB]">
                  <div className="w-12 h-12 rounded-full bg-[#2DD4BF]/10 flex items-center justify-center text-[#2DD4BF]">
                    <MapPin size={20} />
                  </div>
                  <div>
                    <div className="text-sm text-[#6B7280]">Sede</div>
                    <div className="font-semibold text-[#1A1D24]">Italia</div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Form */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <form 
                onSubmit={handleSubmit}
                data-testid="real-estate-form"
                className="bg-white p-8 rounded-lg shadow-lg border border-[#E5E7EB]"
              >
                <div className="grid sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Nome e Cognome *</label>
                    <input
                      type="text"
                      required
                      value={formData.nome}
                      onChange={(e) => setFormData({...formData, nome: e.target.value})}
                      data-testid="form-nome"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent"
                      placeholder="Mario Rossi"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Email *</label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      data-testid="form-email"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent"
                      placeholder="mario@email.com"
                    />
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Telefono</label>
                    <input
                      type="tel"
                      value={formData.telefono}
                      onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                      data-testid="form-telefono"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent"
                      placeholder="+39 333 123 4567"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Tipo Richiesta *</label>
                    <select
                      required
                      value={formData.tipoRichiesta}
                      onChange={(e) => setFormData({...formData, tipoRichiesta: e.target.value})}
                      data-testid="form-tipo-richiesta"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent bg-white"
                    >
                      <option value="">Seleziona...</option>
                      <option value="Acquisto">Voglio Acquistare</option>
                      <option value="Vendita">Voglio Vendere</option>
                      <option value="Valutazione">Valutazione Immobile</option>
                      <option value="Investimento">Consulenza Investimento</option>
                      <option value="Ristrutturazione">Consulenza Ristrutturazione</option>
                      <option value="Altro">Altro</option>
                    </select>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Tipo Immobile</label>
                    <select
                      value={formData.tipoImmobile}
                      onChange={(e) => setFormData({...formData, tipoImmobile: e.target.value})}
                      data-testid="form-tipo-immobile"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent bg-white"
                    >
                      <option value="">Seleziona...</option>
                      <option value="Appartamento">Appartamento</option>
                      <option value="Villa">Villa / Casa Indipendente</option>
                      <option value="Rustico">Rustico / Casale</option>
                      <option value="Commerciale">Locale Commerciale</option>
                      <option value="Terreno">Terreno</option>
                      <option value="Altro">Altro</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#1A1D24] mb-2">Zona di Interesse</label>
                    <input
                      type="text"
                      value={formData.zona}
                      onChange={(e) => setFormData({...formData, zona: e.target.value})}
                      data-testid="form-zona"
                      className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent"
                      placeholder="Es. Milano Centro, Roma Nord..."
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-[#1A1D24] mb-2">Budget Indicativo</label>
                  <select
                    value={formData.budget}
                    onChange={(e) => setFormData({...formData, budget: e.target.value})}
                    data-testid="form-budget"
                    className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent bg-white"
                  >
                    <option value="">Seleziona...</option>
                    <option value="Fino a €100.000">Fino a €100.000</option>
                    <option value="€100.000 - €250.000">€100.000 - €250.000</option>
                    <option value="€250.000 - €500.000">€250.000 - €500.000</option>
                    <option value="€500.000 - €1.000.000">€500.000 - €1.000.000</option>
                    <option value="Oltre €1.000.000">Oltre €1.000.000</option>
                  </select>
                </div>

                <div className="mb-6">
                  <label className="block text-sm font-medium text-[#1A1D24] mb-2">Descrivi le tue esigenze</label>
                  <textarea
                    rows={4}
                    value={formData.messaggio}
                    onChange={(e) => setFormData({...formData, messaggio: e.target.value})}
                    data-testid="form-messaggio"
                    className="w-full px-4 py-3 border border-[#E5E7EB] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2DD4BF] focus:border-transparent resize-none"
                    placeholder="Raccontaci di più sulle tue esigenze immobiliari..."
                  />
                </div>

                {submitStatus === 'success' && (
                  <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
                    Grazie! La tua richiesta è stata inviata. Ti contatteremo presto.
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    Si è verificato un errore. Riprova o contattaci telefonicamente.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  data-testid="form-submit"
                  className="w-full bg-[#2DD4BF] text-white px-8 py-4 font-semibold rounded-lg hover:bg-[#14B8A6] transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? (
                    'Invio in corso...'
                  ) : (
                    <>
                      Invia Richiesta
                      <Send size={18} />
                    </>
                  )}
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Blog Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div {...fadeUp} className="text-center mb-16">
            <span className="text-[#2DD4BF] text-sm font-semibold tracking-wider uppercase mb-4 block">
              Blog & Risorse
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1A1D24] tracking-tight mb-4">
              Guide e Consigli Immobiliari
            </h2>
            <p className="text-[#6B7280] max-w-xl mx-auto">
              Articoli, guide e approfondimenti per aiutarti a prendere decisioni informate nel mercato immobiliare.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8">
            {blogPosts.map((post, index) => (
              <motion.article
                key={post.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`blog-post-${index}`}
                className="bg-[#F9FAFB] rounded-lg overflow-hidden border border-[#E5E7EB] hover:shadow-lg transition-all group cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-[#2DD4BF] text-white text-xs font-semibold px-3 py-1 rounded-full">
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-[#6B7280] text-sm mb-3">
                    <Calendar size={14} />
                    {post.date}
                  </div>
                  <h3 className="text-lg font-semibold text-[#1A1D24] mb-2 group-hover:text-[#2DD4BF] transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-[#6B7280] text-sm leading-relaxed mb-4">
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-[#2DD4BF] font-medium text-sm group-hover:gap-2 transition-all">
                    Leggi di più
                    <ChevronRight size={16} />
                  </span>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-[#1A1D24] to-[#2D3139] relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200')] bg-cover bg-center opacity-10" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <motion.div {...fadeUp} className="text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-6">
              Hai un Progetto Immobiliare?
            </h2>
            <p className="text-white/70 text-lg max-w-xl mx-auto mb-10">
              Che tu stia cercando casa, vendendo un immobile o valutando un investimento, 
              siamo qui per aiutarti a prendere le decisioni migliori.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="#form-immobiliare"
                data-testid="real-estate-cta-consultation"
                className="inline-flex items-center gap-2 bg-[#2DD4BF] text-white px-8 py-4 font-semibold rounded-sm hover:bg-[#14B8A6] transition-all hover:scale-105 shadow-lg"
              >
                Prenota una Consulenza
                <ArrowUpRight size={20} />
              </a>
              <Link
                to="/services"
                data-testid="real-estate-cta-services"
                className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-8 py-4 font-semibold rounded-sm hover:bg-white/20 transition-all"
              >
                Scopri gli Altri Servizi
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default RealEstatePage;
